module.exports = __webpack_public_path__ + "static/media/homeIcon-active.da1b06bf.svg";